import { Array } from "@siteimprove/alfa-array";
import { Comma } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
import { Specificity } from "../specificity.js";
import { Complex } from "./complex.js";
import { Selector } from "./selector.js";
const { map, separatedList } = Parser;
/**
 * {@link https://drafts.csswg.org/selectors/#selector-list}
 *
 * @public
 */
export class List extends Selector {
    static of(...selectors) {
        return new List(selectors);
    }
    _selectors;
    _length;
    constructor(selectors) {
        super("list", Specificity.max(...selectors.map((selector) => selector.specificity)));
        this._selectors = selectors;
        this._length = selectors.length;
    }
    get selectors() {
        return this._selectors;
    }
    get length() {
        return this._length;
    }
    matches(element, context) {
        return this._selectors.some((selector) => selector.matches(element, context));
    }
    equals(value) {
        return (value instanceof List && Array.equals(value._selectors, this._selectors));
    }
    *[Symbol.iterator]() {
        yield* this._selectors;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            selectors: Array.toJSON(this._selectors),
        };
    }
    toString() {
        return this._selectors.map((selector) => selector.toString()).join(", ");
    }
}
/**
 * @public
 */
(function (List) {
    /**
     * {@link https://drafts.csswg.org/selectors/#typedef-selector-list}
     *
     * @internal
     */
    List.parseList = (parseSelector) => map(separatedList(Complex.parseComplex(parseSelector), Comma.parse), (result) => List.of(...result));
})(List || (List = {}));
//# sourceMappingURL=list.js.map